/**
 * sl-oll9.26: News Portal UI Gating Constants
 *
 * This file provides:
 * - NEWS_PORTAL_ENABLED_CLASS: CSS class constant for the Lit<->React bridge
 * - isNewsPortalEnabledFromBody(): Lit bridge function
 *
 * The body class is toggled by NewsPortalGateProvider.
 */

import { NEWS_PORTAL_ENABLED_CLASS } from '../providers/news-portal-gate-provider';

export { NEWS_PORTAL_ENABLED_CLASS };

/**
 * Check if News Portal is enabled by reading body class.
 * For use in Lit components and non-React code that can't use React hooks.
 */
export function isNewsPortalEnabledFromBody(): boolean {
  return document.body.classList.contains(NEWS_PORTAL_ENABLED_CLASS);
}
